<br>
<div *ngIf="status" class="alert {{status}}">
    <span class="closebtn" onclick="this.parentElement.style.display='none';">&times;</span>
    <strong>Atención: </strong>
    {{message}}
</div>